declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        ready: () => void;
        expand: () => void;
        close: () => void;
        initData: string;
        initDataUnsafe: { user?: { id: number; first_name?: string; username?: string } };
        colorScheme: 'light' | 'dark';
        themeParams: Record<string, string>;
        HapticFeedback: {
          impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void;
          notificationOccurred: (type: 'error' | 'success' | 'warning') => void;
          selectionChanged: () => void;
        };
        MainButton: {
          text: string;
          show: () => void;
          hide: () => void;
          onClick: (fn: () => void) => void;
          offClick: (fn: () => void) => void;
          setText: (text: string) => void;
          enable: () => void;
          disable: () => void;
          showProgress: (leaveActive?: boolean) => void;
          hideProgress: () => void;
        };
        BackButton: {
          show: () => void;
          hide: () => void;
          onClick: (fn: () => void) => void;
          offClick: (fn: () => void) => void;
        };
        openLink: (url: string, options?: { try_instant_view?: boolean }) => void;
        openTelegramLink?: (url: string) => void;
        openInvoice: (url: string, cb?: (status: string) => void) => void;
        downloadFile?: (
          params: { url: string; file_name: string },
          cb?: (accepted: boolean) => void,
        ) => void;
        version?: string;
        isVersionAtLeast?: (version: string) => boolean;
        setHeaderColor: (color: string) => void;
        setBackgroundColor: (color: string) => void;
      };
    };
  }
}

export const tg = () => window.Telegram?.WebApp;

export const initTelegram = () => {
  const w = tg();
  if (!w) return;
  w.ready();
  w.expand();
  try {
    w.setHeaderColor('#09090B');
    w.setBackgroundColor('#09090B');
  } catch {
    // ignore older clients
  }
};

export const haptic = (kind: 'light' | 'medium' | 'heavy' = 'light') => {
  tg()?.HapticFeedback.impactOccurred(kind);
};

export const hapticSuccess = () => tg()?.HapticFeedback.notificationOccurred('success');

export {};
